import React from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';
import FilterPopover from 'talent_matching/components/filters/filter_popover';
import { useCoverageAnnotatedFilterGroups } from 'talent_matching/components/filters/coverage_annotated_filter_groups';

const t = withLocalePrefix('talent_matching.filter_row.advanced_filters');

const AdvancedFilters = () => {
  const { advancedFilterConfig } = useTalentMatchingTabContext();
  const filterGroups = useCoverageAnnotatedFilterGroups(
    advancedFilterConfig.filterGroups
  );

  return (
    <FilterPopover
      fieldName="advancedFilters"
      title={t('title')}
      getButtonLabel={(count: number) => t('button', { count })}
      addLabel={t('add_filter')}
      clearLabel={t('clear')}
      typeOptions={filterGroups}
    />
  );
};

export default AdvancedFilters;
